<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>

    <!-- Posts Listing -->
    <section>
      <div v-if="!showPostContent">
        <h3 class="title-left-border">Posts</h3>
        <hr>
        <div class="mb-8 columns">
          <!-- Busca de Posts -->
          <ValidationObserver
            ref="profileFormObserver"
            tag="form"
            @submit.prevent="validateBeforeSubmit()"
            class="columns column is-multiline is-12"
          >
            <!-- Título -->
            <validation-provider
              rules="alpha_spaces"
              v-slot="{ errors }"
              name="Título"
              class="column min-300"
            >
              <b-field
                label="Título"
                :type="{'is-danger': errors[0]}"
                :message="errors[0]"
              >
                <b-input
                  v-model="search.title"
                  placeholder="Título"
                />
              </b-field>
            </validation-provider>

            <!-- Nome do Autor -->
            <validation-provider
              rules="alpha_spaces"
              v-slot="{ errors }"
              name="Nome do Autor"
              class="column min-300"
            >
              <b-field
                label="Nome do Autor"
                :type="{'is-danger': errors[0]}"
                :message="errors[0]"
              >
                <b-input
                  v-model="search.authorName"
                  placeholder="Nome do Autor"
                />
              </b-field>
            </validation-provider>

            <!-- Sobrenome do Autor -->
            <validation-provider
              rules="alpha_spaces"
              v-slot="{ errors }"
              name="Sobrenome do Autor"
              class="column min-300"
            >
              <b-field
                label="Sobrenome do Autor"
                :type="{'is-danger': errors[0]}"
                :message="errors[0]"
              >
                <b-input
                  v-model="search.authorLastName"
                  placeholder="Sobrenome do Autor"
                />
              </b-field>
            </validation-provider>

            <!-- Criação -->
            <b-field
              label="Data da publicação"
              class="column min-300"
            >
              <b-datepicker
                placeholder="Selecione uma data..."
                icon="calendar-today"
                v-model="search.createdOn"
                :month-names="monthNames"
                :day-names="dayNames"
              >
              </b-datepicker>
            </b-field>

            <!-- Publicado -->
            <b-field
              label="Publicado"
              class="column max-150"
            >
              <b-select
                placeholder="Publicado ?"
                v-model="search.isPublished"
              >
                <option :value="true">
                  Sim
                </option>
                <option :value="false">
                  Não
                </option>
                <option
                  value="all"
                  selected
                >
                  Todos
                </option>
              </b-select>
            </b-field>

            <span class="column is-12">
              <b-button
                class="mr-4"
                type="is-primary"
                native-type="submit"
              >
                Pesquisar
              </b-button>
            </span>

          </ValidationObserver>
        </div>

        <!-- Tabela de Resultados -->

        <div v-if="posts.length">
          <b-table
            :data="posts"
            :paginated="true"
            :per-page="perPage"
            :total="total"
            :current-page.sync="currentPage"
            :pagination-simple="false"
            default-sort="user.name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >

            <template slot-scope="props">

              <!-- Título -->
              <b-table-column
                field="title"
                label="Título"
                sortable
                searchable
              >
                <a
                  @click="viewPost(props.index)"
                  class="underline"
                >{{ props.row.title }}</a>
              </b-table-column>

              <!-- Nome do Autor -->
              <b-table-column
                field="author.name"
                label="Nome do Autor"
                sortable
                searchable
              >
                {{ props.row.author.name }}
              </b-table-column>

              <!-- Sobrenome do Autor -->
              <b-table-column
                field="author.lastName"
                label="Sobrenome do Autor"
                sortable
                searchable
              >
                {{ props.row.author.lastName }}
              </b-table-column>

              <!-- Criação -->
              <b-table-column
                field="createdOn"
                label="Criação"
                sortable
              >
                {{ props.row.createdOn | formatDate }}
              </b-table-column>

              <!-- Publicado -->
              <b-table-column
                field="published"
                label="Publicado ?"
                sortable
              >
                {{ props.row.published ? 'Sim' : 'Não' }}
              </b-table-column>

              <!-- Actions -->
              <b-table-column
                fields="id"
                label="Ações"
                width="200"
              >
                <!-- Aprovar -->
                <b-button
                  type="is-primary"
                  @click="aprove(props.row.id)"
                  class="mr-2"
                >
                  <b-tooltip label="Aprovar Publicação">
                    <b-icon icon="check" />
                  </b-tooltip>
                </b-button>

                <!-- Reprovar -->
                <b-button
                  type="is-secondary"
                  @click="reject(props.row.id)"
                  class="mr-2"
                >
                  <b-tooltip label="Reprovar Publicação">
                    <b-icon icon="cancel" />
                  </b-tooltip>
                </b-button>

                <!-- Apagar -->

                <b-button
                  type="is-danger"
                  @click="confirmDeletePost(props.row.id)"
                  class="mr-2"
                >
                  <b-tooltip label="Apagar Publicação">
                    <b-icon icon="delete" />
                  </b-tooltip>
                </b-button>

                <b-modal
                  has-modal-card
                  :active.sync="isPostEditModalOpen"
                  trap-focus
                  aria-role="dialog"
                  aria-modal
                >
                  <div>Post Content</div>
                </b-modal>
              </b-table-column>

            </template>
          </b-table>
        </div>
        <div
          v-else
          class="text-center"
        >
          <h3>Nenhum Resultado Disponível</h3>
        </div>
      </div>
      <div v-else>
        <b-button
          type="is-primary"
          @click="()=>{showPostContent = false}"
        >
          <b-tooltip label="Voltar">

            <b-icon icon="arrow-left"></b-icon>
          </b-tooltip>
        </b-button>
        <section class="content-section max-h-screen overflow-y-auto">
          <div
            v-html="selectedPost.content"
            class="post-content"
          >
          </div>
        </section>
      </div>

    </section>

  </div>
</template>

<script>
import { postsCollection } from '../../firebaseConfig'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'
import { formatDateMixin } from '../../mixins/filters'

const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
const dayNames = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  mixins: [formatDateMixin],
  data () {
    return {
      search: {
        title: '',
        authorName: '',
        authorLastName: '',
        createdOn: null,
        isPublished: 'all'
      },
      isPostEditOpen: false,
      lastQueried: null,
      currentPage: 1,
      perPage: 5,
      total: 0,
      performingRequest: false,
      monthNames,
      dayNames,
      showPostContent: false,
      selectedPost: {}
    }
  },

  computed: {
    ...mapState(['posts'])
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.profileFormObserver.validate()

      if (isValid) {
        this.searchPosts()
      } else {
        console.log('inválido')
      }
    },

    async searchPosts () {
      try {
        this.performingRequest = true

        await this.$store.dispatch('fetchPosts', this.search)

        this.total = this.$store.state.posts.length
      } catch (error) {
        console.error(error)
      } finally {
        this.performingRequest = false
      }
    },

    confirmDeletePost (id) {
      this.$buefy.dialog.confirm({
        message: 'Tem certeza que deseja remover este post? Esta ação não poderá ser desfeita.',
        title: 'Remoção de Post',
        confirmText: 'Remover',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deletePost(id)
      })
    },

    async deletePost (id) {
      try {
        this.performingRequest = true
        await postsCollection.doc(id).delete()
        this.$toasted.success('Post removido com sucesso')
      } catch (error) {
        this.$toasted.error('Não foi possível remover este post. Tente novamente mais tarde')
      } finally {
        this.performingRequest = false
      }
    },

    async aprove (id) {
      try {
        this.performingRequest = true
        await postsCollection.doc(id).update({
          published: true
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.performingRequest = false
      }
    },

    async reject (id) {
      try {
        this.performingRequest = true
        await postsCollection.doc(id).update({
          published: false
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.performingRequest = false
      }
    },

    viewPost (id) {
      this.showPostContent = true
      this.selectedPost = this.posts[id]
    }

  }

}
</script>
<style scoped>
.modal section {
  margin: unset !important;
}
.modal-background {
  background-color: rgba(10, 10, 10, 0.25) !important;
}
</style>
